import type { MacroRoutingComponentProps } from './MacroRoutingComponent';

export const MacroRoutingComponent = {
    MountAsync: async (target: HTMLElement, props: MacroRoutingComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { MacroRoutingComponent } = await import('./MacroRoutingComponent');
        return await mountReactComponentAsync(target, MacroRoutingComponent, props);
    }
};
